import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';
import queries from '../../../utils/queries'

const DetalleP = ({elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna1}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna2}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna4}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna5}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna6}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna7}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna8}</td>
      {elemento.columna26!==7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna26!==7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna26!==7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna26!==7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      

      {elemento.columna9==='' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna9==='ALARMA' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna9==='PELIGRO' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna9==='CONFIABLE' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna10==='' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna10==='ALARMA' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna10==='PELIGRO' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna10==='CONFIABLE' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna11==='' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna11==='ALARMA' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna11==='PELIGRO' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna11==='CONFIABLE' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna12==='' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      {elemento.columna12==='ALARMA' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      {elemento.columna12==='PELIGRO' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      {elemento.columna12==='CONFIABLE' && elemento.columna26===7 &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}></td>
  
    </tr>
  )
};

const ListaP = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleP elemento={elemento}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetallePr = ({elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna1}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna2}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna4}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna5}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna6}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna7}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna8}</td>
      {/* <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td> */}

      {elemento.columna27==='' && 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna27==='ALARMA' && 
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna27==='PELIGRO' && 
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna27==='CONFIABLE' && 
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna9}</td>
      }
      {elemento.columna28==='' && 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna28==='ALARMA' && 
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna28==='PELIGRO' && 
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna28==='CONFIABLE' && 
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna10}</td>
      }
      {elemento.columna29==='' && 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna29==='ALARMA' && 
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna29==='PELIGRO' && 
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna29==='CONFIABLE' && 
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna11}</td>
      }
      {elemento.columna30==='' && 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      {elemento.columna30==='ALARMA' && 
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      {elemento.columna30==='PELIGRO' && 
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      {elemento.columna30==='CONFIABLE' && 
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna12}</td>
      }
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.columna13}</td>

    </tr>
  )
};

const ListaPr = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetallePr elemento={elemento}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class VerResLab2 extends React.Component {

  render(){
    let list = [], list1 = []
    if(this.props.allInflabRtes.allInflabRtes){list = this.props.allInflabRtes.allInflabRtes}
    if(this.props.allInflabRtes1.allInflabRtes){list1 = this.props.allInflabRtes1.allInflabRtes}
      return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1">         
            <div>
              <div style={{height: '25em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Descripción</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}></th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}></th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}></th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}></th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}></th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Hist. 3</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Hist. 2</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Hist. 1</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Actual</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}></th>
                    </tr>
                  </thead>
                  <ListaP list={list1}/>
                </table>
                <p></p>
              </div>
            </div>

            <div>
              <div style={{height: '64em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Tipo prueba</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Prueba</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Norma</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Alarma</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Peligro</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Aceite nuevo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Hist. 3</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Hist. 2</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Hist. 1</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Actual</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Variación</th>
                    </tr>
                  </thead>
                  <ListaPr list={list}/>
                </table>
                <p></p>
              </div>
            </div>

          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'mecInflab': ${props.idLista.mecInflab}}}, 
      {"$unwind": "$reportes"},
      {$project: {_id: "$reportes.columna26",
      columna1: '$reportes.columna1', columna2: '$reportes.columna2', columna3: '$reportes.columna3', 
      columna4: '$reportes.columna4', columna5: '$reportes.columna5', columna6: '$reportes.columna6', 
      columna7: '$reportes.columna7', columna8: '$reportes.columna8', columna9: '$reportes.columna9', 
      columna10: '$reportes.columna10', columna11: '$reportes.columna11', columna12: '$reportes.columna12', 
      columna13: '$reportes.columna13', columna14: '$reportes.columna14', columna15: '$reportes.columna15', 
      columna16: '$reportes.columna16', columna17: '$reportes.columna17', columna18: '$reportes.columna18', 
      columna19: '$reportes.columna19', columna20: '$reportes.columna20', columna21: '$reportes.columna21', 
      columna22: '$reportes.columna22', columna23: '$reportes.columna23', columna24: '$reportes.columna24', 
      columna25: '$reportes.columna25', columna26: '$reportes.columna26', columna27: '$reportes.columna27', 
      columna28: '$reportes.columna28', columna29: '$reportes.columna29', columna30: '$reportes.columna30'  
    }},
    {$match: {'columna26': {$gt: 18, $lt: 60}}},
    {$sort: {columna26: 1}}
  ]`}}}}), 
 
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'mecInflab': ${props.idLista.mecInflab}}}, 
      {"$unwind": "$reportes"},
      {$project: {_id: "$reportes.columna26",
      columna1: '$reportes.columna1', columna2: '$reportes.columna2', columna3: '$reportes.columna3', 
      columna4: '$reportes.columna4', columna5: '$reportes.columna5', columna6: '$reportes.columna6', 
      columna7: '$reportes.columna7', columna8: '$reportes.columna8', columna9: '$reportes.columna9', 
      columna10: '$reportes.columna10', columna11: '$reportes.columna11', columna12: '$reportes.columna12', 
      columna13: '$reportes.columna13', columna14: '$reportes.columna14', columna15: '$reportes.columna15', 
      columna16: '$reportes.columna16', columna17: '$reportes.columna17', columna18: '$reportes.columna18', 
      columna19: '$reportes.columna19', columna20: '$reportes.columna20', columna21: '$reportes.columna21', 
      columna22: '$reportes.columna22', columna23: '$reportes.columna23', columna24: '$reportes.columna24', 
      columna25: '$reportes.columna25', columna26: '$reportes.columna26', columna27: '$reportes.columna27', 
      columna28: '$reportes.columna28', columna29: '$reportes.columna29', columna30: '$reportes.columna30'  
    }},
    {$match: {'columna26': {$gt: 6, $lt: 19}}},
    {$sort: {columna26: 1}}
  ]`}}}})

)(VerResLab2)
